.devtools {
  display: grid;
  grid-area: footer;
  grid-template-rows: 1fr auto;
  max-height: 40dvh;
  overflow: auto;
  border-top: 1px solid var(--mantine-color-dark-3);
}

.devtools-nav {
  display: flex;
  gap: calc(var(--mantine-spacing-md) * 0.2);
  justify-content: end;
  padding: calc(var(--mantine-spacing-md) * 0.2);
}

.devtools-instance {
  display: none;
  &.devtools-instance-enabled {
    display: contents;
  }
}

.devtools-panel {
  overflow: auto;
  & > div {
    max-height: 100%;
    overflow: auto;
  }
}
